import Vue from 'vue'
import VueRouter from 'vue-router'
import BAT from '../views/BAT.vue'
import Orders from '../views/Orders.vue'
import ProductionsList from '../views/ProductionsList.vue'
import AuDepart from '../views/AuDepart.vue'
import Incident from '../views/Incident.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BAT',
    component: BAT
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders
  },
  {
    path: '/order/:id',
    name: 'Order',
    component: Orders,
    props: true
  },
  {
    path: '/productions',
    name: 'Production',
    component: ProductionsList
  },
  {
    path: '/audepart',
    name: 'Au départ',
    component: AuDepart
  },
  {
    path: '/incident',
    name: 'Suivi d\'incident',
    component: Incident
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
